export const sliderItems = [
    {
        id: 1,
        img: "https://pbs.twimg.com/media/FD1C5_dXoAATaft?format=jpg&name=large",
        title: "SRPING SALE",
        desc: "FALL IN LOVE WITH THE BEST THINGS IN THIS SEASON",
        bg: "F5FFFA",
    },
    {
        id: 2,
        img: "https://pbs.twimg.com/media/FD13riUWEAo4ZhQ?format=jpg&name=large",
        title: "SUMMER SALE",
        desc: "YOUR FAVORITE PRODUCTS MADE AFFORDABLE FOR YOU",
        bg: "F0F0FF",
    },
    {
        id: 3,
        img: "https://pbs.twimg.com/media/FIGZTTBXEAYSQsX?format=jpg&name=large",
        title: "POPULAR SALE",
        desc: "A NEW COLLECTION HAS ARCHIVES",
        bg: "E6E6FA",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dwbb002385/1_front_750/00468109-02.jpg?sw=1000&sh=1500",
        title: "SHIRT STYLE",
        cat: "Shirt"
    },
    {
        id: 2,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw780c9c2b/1_front_750/00445472-02.jpg?sw=1000&sh=1500",
        title: "DENIM JACKETS",
        cat: "Jacket"
    },
    {
        id: 3,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw529c356a/1_front_750/00457595-01.jpg?sw=1000&sh=1500",
        title: "CASUAL LOVE",
        cat: "Bottom"
    },
];

export const PopularProducts = [
    {
        id: 1,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw851bf711/1_front_750/00456508-01.jpg?sw=1000&sh=1500",
    },
    {
        id: 2,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw18128fb3/1_front_750/00468556-01.jpg?sw=1000&sh=1500",
    },
    {
        id: 3,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw690969f1/4_full_750/00462213-02.jpg?sw=1000&sh=1500",
    },
    {
        id: 4,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dwffbf16e4/3_back_750/00452859-01.jpg?sw=1000&sh=1500",
    },
    {
        id: 5,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw1c9656dd/1_front_750/00452866-02.jpg?sw=1000&sh=1500",
    },
    {
        id: 6,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dwdb362896/1_front_750/00448311-01.jpg?sw=1000&sh=1500",
    },
    {
        id: 7,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw0d20e962/2_side_750/00469421-04.jpg?sw=1000&sh=1500",
    },
    {
        id: 8,
        img: "https://www.forever21.com/dw/image/v2/BFKH_PRD/on/demandware.static/-/Sites-f21-master-catalog/default/dw883036d9/5_detail_750/00463993-01.jpg?sw=1000&sh=1500",
    },
];

export const NavBar = [
    {
        img: "https://www.kindpng.com/picc/m/22-223863_no-avatar-png-circle-transparent-png.png",
    }
]